import {
  IconCircleCheck,
  IconCircleX,
  IconInfoCircle,
} from '@tabler/icons-react';
import { BenefitStatus } from '@zorro/clients';
import { PillColor } from '@zorro/design-system/v2/Pill';
import {
  IconHalfCircle,
  IconQuarterCircle,
  IconThreeQuarterCircle,
} from '@zorro/shared/assets';
import { Icon } from '@zorro/web/design-system';
import { ReactElement } from 'react';
import { $enum } from 'ts-enum-util';

export type BenefitStatusBadgeView = {
  label: string;
  color: PillColor;
  icon: ReactElement;
};

export const getBenefitStatusBadgeView = (
  status: BenefitStatus | undefined | null
): BenefitStatusBadgeView | undefined =>
  $enum.mapValue(status).with<BenefitStatusBadgeView | undefined>({
    [BenefitStatus.AWAITING_MEDICAL]: {
      label: 'Awaiting medical',
      color: 'orange',
      icon: (
        <Icon
          color="var(--color-icon-fill-tag-orange)"
          icon={IconInfoCircle}
          size={24}
        />
      ),
    },
    [BenefitStatus.READY_TO_APPLY]: {
      label: 'Ready to apply',
      color: 'yellow',
      icon: (
        <Icon
          color="var(--color-icon-stroke-tag-yellow)"
          icon={IconInfoCircle}
          size={24}
        />
      ),
    },
    [BenefitStatus.AWAITING_EMPLOYEE]: {
      label: 'Awaiting employee',
      color: 'indigo',
      icon: <IconQuarterCircle color="var(--color-icon-fill-tag-indigo)" />,
    },
    [BenefitStatus.CARRIER_APPLICATION_SENT]: {
      label: 'Carrier application sent',
      color: 'indigo',
      icon: <IconHalfCircle color="var(--color-icon-fill-tag-indigo)" />,
    },
    [BenefitStatus.AWAITING_PAYMENT]: {
      label: 'Awaiting payment',
      color: 'indigo',
      icon: (
        <IconThreeQuarterCircle color="var(--color-icon-fill-tag-indigo)" />
      ),
    },
    [BenefitStatus.ENROLLMENT_CONFIRMED]: {
      label: 'Confirmed',
      color: 'green',
      icon: (
        <Icon
          color="var(--color-icon-fill-tag-green)"
          icon={IconCircleCheck}
          size={24}
        />
      ),
    },
    [BenefitStatus.ACTIVE]: {
      label: 'Active',
      color: 'green',
      icon: (
        <Icon
          color="var(--color-icon-fill-tag-green)"
          icon={IconCircleCheck}
          size={24}
        />
      ),
    },
    [BenefitStatus.ENDED]: {
      label: 'Ended',
      color: 'steel',
      icon: (
        <Icon
          color="var(--color-icon-fill-tag-steel)"
          icon={IconCircleX}
          size={24}
        />
      ),
    },
    [BenefitStatus.IN_CART]: undefined,
    [$enum.handleUnexpected]: undefined,
    [$enum.handleUndefined]: undefined,
    [$enum.handleNull]: undefined,
  });
